
import React, { createContext, useContext, useState, useEffect } from 'react';
import Cookies from 'js-cookie';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    
    useEffect(() => {
        const checkCookie = () => {
            const cookie = Cookies.get('isAuthenticated');
            const cookieExpiry = Cookies.get('authExpiry');
            
            if (cookie && cookieExpiry) {
                const expiryDate = new Date(cookieExpiry);
                const now = new Date();
                
                if (now >= expiryDate) {
                    logout();
                } else {
                    setIsAuthenticated(true);
                }
            } else if (!cookie) {
                setIsAuthenticated(false);
            }
        };
        checkCookie();
        const interval = setInterval(checkCookie, 3600000); 

        return () => clearInterval(interval);
    }, []);
    
    const login = () => {
        const expiryDate = new Date();
        expiryDate.setDate(expiryDate.getDate() + 7); 
        
        setIsAuthenticated(true);
        Cookies.set('isAuthenticated', true, { expires: 7 });
        Cookies.set('authExpiry', expiryDate.toISOString(), { expires: 7 });
    };
    
    const logout = () => {
        setIsAuthenticated(false);
        Cookies.remove('isAuthenticated');
        Cookies.remove('authExpiry');
    };
    
    return (
        <AuthContext.Provider value={{ 
            isAuthenticated, 
            login, 
            logout,
            expiryDate: Cookies.get('authExpiry') 
        }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => {
    return useContext(AuthContext);
};